export default {
  init() {
    $(document).ready(function () {
      setTimeout(function () {
        $('.edit-post-visual-editor').on('click', 'a', function (e) {
          e.preventDefault();
        });
      }, 1000);
    });
  },
};
